<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper" style="min-height: 307px">

  <mat-card class="example-card">
    <mat-card-title>บันทึกขัอมูล แปลงอ้อย
    </mat-card-title>

    <mat-card-actions>
      <div class="row justify-content-md-center">
        <div class="col-md-auto" style="flex-wrap: nowrap;">
          <table>
            <td>
              <mat-form-field appearance="outline" style="max-width: 120px;">
                <mat-label>เลือกปี</mat-label>
                <mat-select name="Year" [(ngModel)]="selectYear" (valueChange)="change_year($event)">
                  <mat-option *ngFor="let item of year" [value]="item">
                    {{item.desc}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </td>
            <td>
              <mat-form-field appearance="outline" style="max-width: 110px;">
                <mat-label>เลือกการค้นหา</mat-label>
                <mat-select (valueChange)="change_search($event)">
                  <mat-option *ngFor="let item of select_search" [value]="item">{{ item.name }}</mat-option>
                </mat-select>
              </mat-form-field>
            </td>

            <td>
              <mat-form-field class="example-form-field" appearance="outline" style="max-width: 150px;">
                <mat-label>{{textshow1}}</mat-label>
                <input matInput type="text" [(ngModel)]="txtsearch" name="txtsearch0" id="txtsearch0" maxlength="13"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57">
                <button *ngIf="txtsearch" matSuffix mat-icon-button aria-label="Clear" (click)="txtsearch=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </td>
          </table>
        </div>
        <div class="col-md-auto" style="text-align:center;">
          <button mat-raised-button color="warn" [disabled]="!selectYear || !txtsearch"
            (click)="lodad_api();">ค้นหา</button>
        </div>

        <div class="col-md-auto">
          <ul class="nav nav-tabs mb-4" role="tablist" style="text-align:center;flex-wrap: wrap;">
            <li class="nav-item">
              <a class="nav-link active btn btn-outline-success" (click)="s_obr=1; set_unselect()" data-toggle="tab">
                งวดตัด </a>
            </li>
            <li class="nav-item">
              <a class="nav-link btn btn-outline-success" (click)="s_obr=2; set_unselect()" data-toggle="tab"> กลุ่มตัด
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link btn btn-outline-success" (click)="s_obr=3; set_unselect()" data-toggle="tab">
                กลุ่มบำรุง
              </a>
            </li>
            <!--<li class="nav-item">
              <a class="nav-link btn btn-outline-success" (click)="s_obr=4; set_unselect()" data-toggle="tab"> ตัน
                สูญเสีย </a>
            </li>
            <li class="nav-item">
              <a class="nav-link btn btn-outline-success" (click)="s_obr=5; set_unselect()" data-toggle="tab"> ตัดพันธุ์
              </a>
            </li>-->
            <li class="nav-item">
              <a class="nav-link btn btn-outline-success" (click)="s_obr=6; set_unselect()" data-toggle="tab">
                สถานะการตัดชาวไร่ </a>
            </li>
          </ul>
          <!--<mat-tab-group mat-align-tabs="center" dynamicHeight>
              <mat-tab label="งวดตัด" (click)="s_obr=1; set_unselect()"></mat-tab>
              <mat-tab label="กลุ่มตัด" (click)="s_obr=2; set_unselect()"></mat-tab>
              <mat-tab label="กลุ่มบำรุง" (click)="s_obr=3; set_unselect()"></mat-tab>
              <mat-tab label="ตัน สูญเสีย" (click)="s_obr=4; set_unselect()"></mat-tab>
              <mat-tab label="ตัดพันธุ์" (click)="s_obr=5; set_unselect()"></mat-tab>
              <mat-tab label="สถานะการตัดชาวไร่" (click)="s_obr=6; set_unselect()"></mat-tab>
            </mat-tab-group>-->
        </div>
      </div>
      <div class="row justify-content-md-center">
        <!--<div class="col-md-auto">
              <div class="card-header d-flex p-0">
                <h3 class="card-title p-3">รายการมองไปด้านขวาเพื่อดูข้อมูลกลุ่มตัดหรือกลุ่มบำรุงอยู่ </h3>
                <div class="card-tools">
                  <button type="button" class="btn btn-tool" (click)="lodad_api();" *ngIf="DataByZone"><i
                      class="fas fa-sync"></i></button>
                  <button type="button" class="btn btn-tool" data-card-widget="collapse"><i
                      class="fas fa-minus"></i></button>
                </div>
              </div>
            </div>-->
        <div class="col-md-auto" *ngIf="DataByZone">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>ค้นหาแปลง (ข้อมูลในตาราง)</mat-label>
            <input matInput [(ngModel)]="txt" placeholder="Search Here">
          </mat-form-field>
        </div>
        <div class="col-md-auto" *ngIf="DataByZone" style="text-align:left">
          <mat-form-field appearance="outline" *ngIf="s_obr==1">
            <mat-label>เลือกงวดตัด</mat-label>
            <mat-select required [(ngModel)]="data_select">
              <mat-option [value]="['','']" selected>
                +++ ไม่เลือกรายการ +++</mat-option>
              <mat-option *ngFor="let item of timecut" [value]="[item.period]">
                {{item.period_name1}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" *ngIf="s_obr==2">
            <mat-label>เลือกกลุ่มตัด</mat-label>
            <mat-select required [(ngModel)]="data_select">
              <mat-form-field class="example-form-field" appearance="fill">
                <mat-label>ค้นหา -*กลุ่มตัด*-</mat-label>
                <input matInput type="text" style="text-align:center" [(ngModel)]="txtFindIn[2]">
                <button *ngIf="txtFindIn[2]" matSuffix mat-icon-button aria-label="Clear"
                  (click)="txtFindIn[2]=''"><mat-icon>close</mat-icon></button>
              </mat-form-field>
              <mat-option [value]="['','']" selected>
                +++ ไม่เลือกรายการ +++</mat-option>
              <mat-option *ngFor="let item of Maincut | filter:txtFindIn[2]" [value]="[item.groupcode,item.groupname]">
                {{item.groupcode}}, {{item.h_fmname}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" *ngIf="s_obr==3">
            <mat-label>เลือกกลุ่มบำรุง</mat-label>
            <mat-select required [(ngModel)]="data_select">
              <mat-form-field class="example-form-field" appearance="fill">
                <mat-label>ค้นหา -*กลุ่มบำรุง*-</mat-label>
                <input matInput type="text" style="text-align:center" [(ngModel)]="txtFindIn[3]">
                <button *ngIf="txtFindIn[3]" matSuffix mat-icon-button aria-label="Clear"
                  (click)="txtFindIn[3]=''"><mat-icon>close</mat-icon></button>
              </mat-form-field>
              <mat-option [value]="['','']" selected>
                +++ ไม่เลือกรายการ +++</mat-option>
              <mat-option *ngFor="let item of Mainrepair | filter:txtFindIn[3]"
                [value]="[item.groupcode,item.groupname]">
                {{item.groupcode}}, {{item.h_fmname}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-auto text-center" *ngIf="DataByZone||selectYear.status==1">
          <button type="button" class="btn btn-primary position-relative" [disabled]="data_select.length==0"
            (click)="saveData()">บันทึก
            <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
              {{edit_length}}
              <span class="visually-hidden">unread messages</span>
            </span>
          </button>
          <mat-spinner *ngIf="loader[1]"></mat-spinner>
        </div>
      </div>
      <mat-progress-bar *ngIf="loader[0]" mode="indeterminate"></mat-progress-bar>
      <!--<mat-spinner *ngIf="loader[0]"></mat-spinner>-->
    </mat-card-actions>
  </mat-card>
  <mat-card>
    <div class="table-responsive p-2" *ngIf="DataByZone.length" style="height: 600px">
      <table class="table table-hover table-striped table-head-fixed table-bordered">
        <thead>
          <tr style="text-align:center">
            <th scope="col"></th>
            <th scope="col">โซน</th>
            <th scope="col">รูท</th>
            <th scope="col">หมายเลขแปลง</th>
            <th scope="col" class="text-nowrap">ชื่อ - สกุล</th>
            <th scope="col">ประเภทอ้อย</th>
            <th scope="col">พื้นที่คงเหลือ</th>
            <th scope="col">ประเมินคงเหลือ</th>
            <th scope="col">ตัน/ไร่</th>
            <th scope="col">อ้อยเข้า</th>
            <th scope="col">เลือก</th>
            <th scope="col">งวดตัด</th>
            <th scope="col">
              <b *ngIf="s_obr==1"></b>
              <b *ngIf="s_obr==2">กลุ่มตัด</b>
              <b *ngIf="s_obr==3">กลุ่มบำรุง</b>
              <b *ngIf="s_obr==4">ตันสูญเสีย</b>
              <b *ngIf="s_obr==5">ตัดพันธุ์</b>
              <b *ngIf="s_obr==6">สถานะการตัด(ชาวไร่)</b>
            </th>
            <!--<th style="text-align:center"  scope="col">ยืนยันพื้นที่</th>
                                      <th scope="col">Action</th>!-->
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of DataByZone | filter:txt; let i = index;" style="text-align:center">
            <td>{{i+1}}</td>
            <td>{{item.supzone}}</td>
            <td>{{item.route}}</td>
            <td>{{item.intlandno}}</td>
            <td class="text-nowrap">{{item.fmname}}</td>
            <td>{{item.CaneTypeName}}</td>
            <td>{{item.landvalue_left | number:'1.2-2'}}</td>
            <td>{{item.Assess_left | number:'1.2-2'}}</td>
            <td>{{item.Ton | number}}</td>
            <td>{{item.canein | number:'1.2-2'}}</td>
            <td>
              <section class="example-section" *ngIf="s_str > 0">
                <mat-checkbox [(ngModel)]="item.selected" (ngModelChange)="edid_change()"
                  class="example-margin"></mat-checkbox>
              </section>
            </td>
            <td style="text-align:right">
              {{item.period_cut}}
              <!--<a *ngIf="selectYear.status==s_str&&selectYear.status==1&&s_obr==1" class='far fa-edit'
                style='font-size:24;color:#001aff' (click)="open_menu(1,[item])"> </a>-->
            </td>
            <td *ngIf="s_obr==1"></td>
            <td style="text-align:right" *ngIf="s_obr==2">
              {{item.groupCode}}
              <!--<a *ngIf="selectYear.status==s_str&&selectYear.status==1" class='far fa-edit'
                style='font-size:24;color:red' (click)="open_menu(2,[item])"> </a>-->
            </td>
            <td style="text-align:right" *ngIf="s_obr==3">
              {{item.groupCode_m}}
              <!--<a *ngIf="selectYear.status==s_str&&selectYear.status==1" class='far fa-edit'
                    style='font-size:24;color:red' (click)="open_menu(3,[item])"> </a>-->
            </td>
            <td style="text-align:right" *ngIf="s_obr==4">
              {{item.ton_lost}}
              <!--<a *ngIf="selectYear.status==s_str&&selectYear.status==1" class='far fa-edit'
                style='font-size:24;color:red' (click)="open_menu(4,[item])"> </a>-->
            </td>
            <td style="text-align:right" *ngIf="s_obr==5">
              {{item.Cutseed}}
              <!--<a *ngIf="selectYear.status==s_str&&selectYear.status==1" class='far fa-edit'
                style='font-size:24;color:red' (click)="open_menu(5,[item])"> </a>-->
            </td>
            <td style="text-align:center" *ngIf="s_obr==6">
              {{item.cutstatus_fm}}
              <a *ngIf="selectYear.status==s_str&&selectYear.status==1&&item.cutstatus_fm=='F'" class='far fa-edit'
                style='font-size:24;color:red' (click)="cancel_cutstatus_fm(item.itid)">
              </a>
              <!--<button type="button" class="btn btn-outline-warning" (click)="open_menu(6,[item])"
                *ngIf="selectYear.status==s_str&&selectYear.status==1&&item.qtype=='2'"> เลือกวันตัด
              </button>-->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </mat-card>
</div>
<!-- Modal งวดตัด -->
<div class="modal fade" id="edittime" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">แก้ไขข้อมูลงวดตัด</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <p>งวดตัด : <input type="text" class="form-control" value="{{s_data[1]}}" disabled>
          <input type="text" class="form-control" list="timecut" value="{{s_data[1]}}"
            placeholder="กรอกข้อมูลค้นหาแล้วกดเลือกจึงจะบันทึก">
          <datalist id="timecut">
            <option *ngFor="let item of timecut" [value]="item.period">
              {{item.period_name1}}
            </option>
          </datalist>
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
          (click)="Edittime();">บันทึกรายการ</button>
      </div>
    </div>
  </div>
</div>
<!-- MOdal -->
<!-- Modal กลุ่มตัด -->
<div class="modal fade" id="editcut" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">แก้ไขข้อมูลกลุ่มตัด</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <p>กลุ่มตัด : <input type="text" class="form-control" value="{{s_data[1]}}" disabled>
          <input type="text" class="form-control" list="cutgroup" value="{{s_data[1]}}"
            placeholder="กรอกข้อมูลค้นหาแล้วกดเลือกจึงจะบันทึก">
          <datalist id="cutgroup">
            <option *ngFor="let item of Maincut" [value]="[item.groupcode,item.groupname]">
              รหัสกลุ่มตัด : {{item.categoryGroup}} ชื่อหัวหน้ากลุ่ม : {{item.h_fmname}}
            </option>
          </datalist>
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
          (click)="Editgroupandtime();">บันทึกรายการ</button>
      </div>
    </div>
  </div>
</div>
<!-- MOdal -->

<!-- Modal  ยืนยันพื้นที่ -->
<div class="modal fade" id="checkcut" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header bg-success">
        <h2 class="modal-title" id="exampleModalLabel">ยืนยันพื้นที่</h2>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <select class="form-control" [(ngModel)]="select_list">
          <option [ngValue]="''" selected>กรุณาเลือก</option>
          <option [ngValue]="1">ไว้ตอ</option>
          <option [ngValue]="2">รื้อตอ</option>
          <option [ngValue]="3">เลิกปลูก</option>
        </select>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
          (click)="Comfirmarea();">บันทึกรายการ</button>
      </div>
    </div>
  </div>
</div>
<!-- MOdal -->

<!-- Modal กลุ่มบำรุง -->
<div class="modal fade" id="editrepair" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">แก้ไขกลุ่มบำรุง</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <p>กลุ่มบำรุง : <input type="text" class="form-control" value="{{s_data[1]}}" disabled>
          <input type="text" class="form-control" list="cutrepair" value="{{s_data[1]}}" [(ngModel)]="groupcode_m"
            [ngModelOptions]="{standalone: true}" placeholder="กรอกข้อมูลค้นหาแล้วกดเลือกจึงจะบันทึก">
          <datalist id="cutrepair">
            <option *ngFor="let item of Mainrepair" [value]="[item.groupcode,item.groupname]">
              รหัสกลุ่มบำรุง : {{item.categoryGroup}} หัวหน้ากลุ่ม : {{item.h_fmname}}
            </option>
          </datalist>
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <!--<button type="button" class="btn btn-primary"data-bs-dismiss="modal" (click)="Comfirmarea();">บันทึกรายการ</button>-->
      </div>
    </div>
  </div>
</div>
<!-- MOdal -->

<!-- Modal แก้ไขตันสูญเสีย -->
<div class="modal fade" id="edittonlost" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">แก้ไขตันสูญเสีย</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <form #f="ngForm">
          <p>ตันสูญเสีย :
            <input type="number" class="form-control" value="{{s_data[1]}}" disabled>
            <input type="number" class="form-control" value="{{s_data[1]}}" name="tonlost" ngModel min="0"
              placeholder="กรอกข้อมูลค้นหาแล้วกดเลือกจึงจะบันทึก">
          </p>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
          (click)="Edit_data(f.value.tonlost,'ton_lost');">บันทึกรายการ</button>
      </div>
    </div>
  </div>
</div>
<!-- MOdal -->

<!-- Modal ตัดพันธู์ -->
<div class="modal fade" id="editcutseed" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">แก้ไข ตัดพันธู์</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <form #e="ngForm">
          <p>ตัดพันธู์ :
            <input type="number" class="form-control" value="{{s_data[1]}}" disabled>
            <input type="number" class="form-control" value="{{s_data[1]}}" name="Cutseed" ngModel min="0"
              placeholder="กรอกข้อมูลค้นหาแล้วกดเลือกจึงจะบันทึก">
          </p>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
          (click)="Edit_data(e.value.Cutseed,'Cutseed');">บันทึกรายการ</button>
      </div>
    </div>
  </div>
</div>
<!-- MOdal -->

<!-- Modal เริ่มตัด - ตัดเสร็จ รถโยน -->
<div class="modal fade" id="editcutStartStop" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">บันทึก เริ่มตัด - ตัดเสร็จ</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">

        <b>วันที่ตัดเดิม </b>
        <b> เริ่มตัด: {{date2th(s_data[1])}}</b>
        <b>, ตัดเสร็จ: {{date2th(s_data[2])}}</b>
        <br><br>
        <label for="cutstartFm">วันเริ่มตัด: {{date2th(s_data[3])}}</label>
        <input type="date" id="cutstart" [(ngModel)]="s_data[3]" [ngModelOptions]="{standalone: true}" name="cutstartFm"
          ngModel>
        <br>
        <label for="cutstopFm">วันตัดเสร็จ: {{date2th(s_data[4])}}</label>
        <input type="date" id="cutstop" [(ngModel)]="s_data[4]" [ngModelOptions]="{standalone: true}" name="cutstopFm"
          ngModel>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
          (click)="set_cutstatus_fm(s_data)">บันทึกรายการ</button>
      </div>
    </div>
  </div>
</div>
<!-- MOdal -->


<app-footer></app-footer>